// state
const state = () => ({
  isProgressBarProduct: false,
  isModalModalUpdateProductLink: false,
  syncStockProgress: false,
  isModalSendProduct: false,
  productDataListPregressBar: [],
  isProductLoadingPregressBar: false,
  updateProductDataTablePregressBar: 0,
  listDataProgressBar : [],
  isOpenModal: false,
  isModalUpdateSalable: false,
  productUpdateSalable: [],
  updateSalable: [],
  isFeedDataProduct:false,
  isFeedDataProductList:false,
  isLoadingTableWarehouse:false,
  isOpenModalUnlink: false,
  listDataProgressBarUnlink : [],

});

// getters
const getters = {};

// actions
const actions = {
  isProgressBarProduct({ commit }, data) {
    commit('setProgressBarProduct', data);
  },
  isModalModalUpdateProductLink({ commit }, data) {
    commit('setModalUpdateProductLink', data);
  },
  syncStockProgress({ commit }, data) {
    commit('syncStockProgress', data);
  },
  isModalSendProduct({ commit }, payload) {
    commit('setModalSendProduct', payload);
  },
  setInProgressBarSendProduct({ commit }, payload) {
    commit('setInProgressBarSendProduct', payload);
  },
  productDataListPregressBar({ commit }, data) {
    commit('setProductDataListPregressBar', data);
  },
  updateProductDataTablePregressBar({ commit }, data) {
    commit('updateProductDataTablePregressBar', data);
  },

  listDataProgressBar({ commit }, data) {
    commit('listDataProgressBar', data);
  },
  updateQty({ commit }, qty) {
    commit('updateQty', qty);
  },
  isOpenModal({ commit }, qty) {
    commit('isOpenModal', qty);
  },
  isModalUpdateSalable({ commit }, data) {
    commit('setModalUpdateSalable', data);
  },
  productUpdateSalable({ commit }, data) {
    commit('setProductUpdateSalable', data);
  },
  updateSalable({ commit }, data) {
    commit('setUpdateSalable', data);
  },
  isFeedDataProduct({ commit }, data) {
    commit('setIsFeedDataProduct', data);
  },
  isFeedDataProductList({ commit }, data) {
    commit('setIsFeedDataProductList', data);
  },
  isLoadingTableWarehouse({ commit }, data) {
    commit('setIsLoadingTableWarehouse', data);
  },
  isOpenModalUnlink({ commit }, qty) {
    commit('isOpenModalUnlink', qty);
  },
  listDataProgressBarUnlink({ commit }, data) {
    commit('listDataProgressBarUnlink', data);
  },
};

// mutations
const mutations = {
  setProgressBarProduct(state, data) {
    state.isProgressBarProduct = data;
  },
  setModalUpdateProductLink(state, data) {
    state.isModalModalUpdateProductLink = data;
  },
  syncStockProgress(state, data) {
    state.syncStockProgress = data;
  },
  setModalSendProduct(state, data) {
    state.isModalSendProduct = data;
  },
  setInProgressBarSendProduct(state, payload) {
    state.productDataListPregressBar['data'] = state.productDataListPregressBar['data'].map(function(Productlist){
      if(!payload.status){
        payload.status = true;
      }

      if(payload.ProductIds.includes(Productlist.id)){
        return {...Productlist, loading: payload.status};
      }

      return Productlist;
    });

    state.isProductLoadingPregressBar = !state.isProductLoadingPregressBar;
  },
  updateProductDataTablePregressBar(state, data) {
    state.productDataListPregressBar['data'] = state.productDataListPregressBar['data'].map(function(Productlist){
      Productlist['loading'] = false;
      return Productlist;
    });
    state.isProductLoadingPregressBar = !state.isProductLoadingPregressBar;
    state.updateProductDataTablePregressBar++;
  },
  setProductDataListPregressBar(state, data) {
    state.productDataListPregressBar = data;
  },
  listDataProgressBar(state, data) {
    state.listDataProgressBar = data;
  },
  updateQty(state, qty) {
    state.listDataProgressBar.quantity = qty;
  },
  isOpenModal(state, data) {
    state.isOpenModal = data;
  },
  setModalUpdateSalable(state, data) {
    state.isModalUpdateSalable = data;
  },
  setProductUpdateSalable(state, data) {
    state.productUpdateSalable = data;
  },
  setUpdateSalable(state, data) {
    state.updateSalable = data;
  },
  setIsFeedDataProduct(state, data) {
    state.isFeedDataProduct = data;
  }, 
  setIsFeedDataProductList(state, data) {
    state.isFeedDataProductList = data;
  }, 
  setIsLoadingTableWarehouse(state, data) {
    state.isLoadingTableWarehouse = data;
  },
  listDataProgressBarUnlink(state, data) {
    state.listDataProgressBarUnlink = data;
  },
  isOpenModalUnlink(state, data) {
    state.isOpenModalUnlink = data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/product.js